const ICONS = 'https://cdn.jsdelivr.net/npm/@lobehub/icons-static-svg@1.95.1/icons'
const m = (id, label) => ({ id, label })

export const CUSTOM_PROVIDERS_PART02 = [
  {
    id: 'mistral',
    label: 'Mistral AI',
    tagline: 'Mistral Large · Codestral',
    iconUrl: `${ICONS}/mistral-color.svg`,
    keyPattern: /^[A-Za-z0-9]{32}$/,
    keyHint: 'Mistral keys are 32 letters and digits',
    keyUrl: 'https://console.mistral.ai/api-keys',
    models: [m('mistral-large-latest', 'Mistral Large'), m('codestral-latest', 'Codestral'), m('mistral-small-latest', 'Mistral Small')],
  },
  {
    id: 'groq',
    label: 'Groq',
    tagline: 'Llama at very low latency',
    iconUrl: `${ICONS}/groq.svg`,
    keyPattern: /^gsk_[A-Za-z0-9]{20,}$/,
    keyHint: 'Groq keys start with gsk_',
    keyUrl: 'https://console.groq.com/keys',
    models: [m('llama-3.3-70b-versatile', 'Llama 3.3 70B'), m('llama-3.1-8b-instant', 'Llama 3.1 8B')],
  },
  {
    id: 'openrouter',
    label: 'OpenRouter',
    tagline: 'Hundreds of models, one key',
    iconUrl: `${ICONS}/openrouter.svg`,
    keyPattern: /^sk-or-[A-Za-z0-9_-]{20,}$/,
    keyHint: 'OpenRouter keys start with sk-or-',
    keyUrl: 'https://openrouter.ai/keys',
    models: [m('openai/gpt-4.1', 'GPT-4.1'), m('anthropic/claude-sonnet-5.5', 'Claude Sonnet 5.5'), m('google/gemini-2.5-pro', 'Gemini 2.5 Pro')],
  },
]
